import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import TextField from '../../../shared-components/TextField/TextField';
import { isEmpty, isValidDateOfBirth as isValidDateOfBirthHelper } from '../../../shared-components/FormElement/FormElementUtils';
import { connect } from 'react-redux';
import {FORM_ID} from '../../../framework/App/AppConstants';
import _ from 'lodash';

const LOCALE_PREFIX = 'US/pages/PersonalInformationPage/DateOfBirth';

export const isValidDateOfBirth = (underAgeMsg, errorMsg, usState) => (value) => {
    return isValidDateOfBirthHelper(value, 'MM/DD/YYYY', underAgeMsg, errorMsg, usState);
};

export class DateOfBirth extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        usState: PropTypes.string.isRequired
    };

    render() {
        const { intl, usState } = this.props;

        return (
            <Field
                id="dob"
                name="dob"
                type="tel"
                component={TextField}
                autoComplete="disabled"
                autoCorrect="off"
                autoCapitalize="off"
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.dob-placeholder`})}
                mask="99/99/9999"
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.dob-label`})}
                validate={[
                    isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.dob-empty`})),
                    isValidDateOfBirth(
                        intl.formatMessage({id: `${LOCALE_PREFIX}.dob-underage`}),
                        intl.formatMessage({id: `${LOCALE_PREFIX}.dob-invalid`}),
                        usState
                    )
                ]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    usState : _.get(state, `form.${FORM_ID}.values.state`)
});

export default connect(mapStateToProps)(injectIntl(DateOfBirth));
